import { ActionStatus } from "sprint-common-web";

import { CloudFileStatus } from "../../../../common/types/CloudFileStatus";
import { CloudFileListingItem } from "../../../types/CloudFileListingItem";

export interface RejectCloudFileItem {
    id: string;
    filePath: string;
    filename: string;
    reference: string;
    originator: string;
    arrivalDate: string;
    status: CloudFileStatus;
}

export type ProcessRejectCloudFileItem = RejectCloudFileItem & {
    processStatus: ActionStatus;
};

export const mapToRejectCloudFileItem = (item: CloudFileListingItem): RejectCloudFileItem => {
    return {
        id: item.id,
        arrivalDate: item.arrivalDate,
        filePath: item.filePath,
        originator: item.originator,
        filename: item.deliveryFileName,
        reference: item.deliveryRef,
        status: item.status
    };
};
